import { render } from "./ChangelogTable.vue?vue&type=template&id=65c3d9e1&scoped=true&ts=true"
import script from "./ChangelogTable.vue?vue&type=script&lang=ts"
export * from "./ChangelogTable.vue?vue&type=script&lang=ts"

import "./ChangelogTable.vue?vue&type=style&index=0&id=65c3d9e1&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c3d9e1"]])

export default __exports__